import React from 'react';
import { useDispatch } from 'react-redux';
import Tour from 'reactour';
import { saveTour } from 'redux/thunks';
import './TeamBadgesTour.scss';

interface TeamBadgesTourProps {
	open: boolean;
	onClose: () => void;
}

const TeamBadgesTour = (props: TeamBadgesTourProps) => {
	const { open, onClose } = props;
	const dispatch = useDispatch();

	const tourCompleted = () => {
		dispatch(saveTour('TeamBadgesTour'));
	};

	const steps = [
		{
			selector: '',
			content: () => (
				<>
					<div>Behold! Your badges!</div>
					<div className='team-badges-tour__paragraph'>When a season is ended badges will automatically be generated for that season and assigned to members of the team.</div>
					<div className='team-badges-tour__paragraph'>Badges provide a fun way to recognize different members of the team based on their interactions inside of ToA.</div>
					<div className='team-badges-tour__paragraph'>Some badge examples include “Philanthropist”, “Inflator”, and “Sidekick”</div>
				</>
			),
		},
		{
			selector: '#season-select-outlined',
			content: 'You can even change the season to see who won the badges for each season',
		},
	];

	return (
		<Tour
		steps={steps}
		closeWithMask={false}
		disableFocusLock={true}
		disableInteraction={true}
		showCloseButton={true}
		disableKeyboardNavigation={['esc']}
		isOpen={open}
		accentColor='#8524AA'
		lastStepNextButton={
			<div style={{ color: '#8524AA' }}>
				Done
			</div>
		}
		onRequestClose={onClose}
		onAfterOpen={tourCompleted}
		/>
	);
};

export default TeamBadgesTour;
